<template>
    <div>
        <select v-model="current" class="form-control" @change="onChange">
            <option v-for="(value) in availableLocales" v-bind:value="value.id" :selected="value.id === current">
                {{ value.name }}
            </option>
        </select>
    </div>
</template>
<script>

import lang from '../services/lang';

export default {
    data() {
        return {
            current: null,
            availableLocales: [],
        };
    },
    computed: {
    },
    mounted() {
        this.$root.$on('init-locale', (availableLocales, currentLanguage) => {
            this.availableLocales = availableLocales;
            this.current = currentLanguage;
        });
    },
    methods: {
        select: function (_lang) {
            lang.set(_lang, () => {
                window.location.reload();
            });
        },
        onChange: function () {
            this.select(this.current);
        }
    }
}
</script>


// WEBPACK FOOTER //
// I18n.vue?a821b0f4